import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { Modal, ModalType } from '@app/shared/models/modal.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { SharedModule } from '@app/shared/shared.module';
import { NavigationButtonComponent } from '@app/shared/components/navigation-button/navigation-button.component';
import { EventsRepository } from '@app/shared/state/events/events.repository';
import { ShopRatesRepository } from '@app/shared/state/shop-rates/shop-rates.repository';

@Component({
  selector: 'slotcom-randomprize-info-modal',
  templateUrl: './randomprize-info.component.html',
  styleUrls: ['./randomprize-info.component.scss'],
  standalone: true,
  imports: [SharedModule, NavigationButtonComponent],
})
export class RandomPrizeInfoModalComponent implements OnInit {
  private readonly eventManager = inject(EventManager);
  private readonly eventsRepo = inject(EventsRepository);
  private readonly shopRatesRepo = inject(ShopRatesRepository);
  public readonly logger = inject(LoggerService);
  protected readonly randomPrizeInfoModalData = inject<Modal>(MAT_DIALOG_DATA);

  randomPrize = signal<LimitedTimeEvent | null>(null);
  randomPrizeMinPurchase = signal<string>('0');
  randomPrizeCurrencySymbol = signal<string>('');

  hasMinPurchase = computed(() => Number(this.randomPrizeMinPurchase()) !== 0);

  ngOnInit(): void {
    let eventId: string;

    if (this.randomPrizeInfoModalData.data.eventId) {
      eventId = this.randomPrizeInfoModalData.data.eventId;
    } else {
      eventId = this.randomPrizeInfoModalData.data.properties.eventId;
    }

    const evt = this.eventsRepo.getEventById(eventId);
    this.randomPrize.set(evt);

    this.getModalData(evt);
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.randomPrizeInfoModalData.id, ModalType.View, this.randomPrizeInfoModalData)
    );
  }

  private getModalData(randomPrize: LimitedTimeEvent): void {
    const shopItem = this.shopRatesRepo.getShopItemBySku(randomPrize.properties.sku);

    if (!shopItem) {
      this.randomPrizeMinPurchase.set('0');
      this.randomPrizeCurrencySymbol.set('');
      return;
    }
    this.randomPrizeMinPurchase.set(shopItem.amount);
    this.randomPrizeCurrencySymbol.set(shopItem.currencySymbol);
  }
}
